export const getPrizeInfo = state => state.prizeInfo;
export const getCurrentDistributions = state => state.currentDistributions;
